'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bitRetriever;
function bitRetriever(data, depth) {
  var leftOver = [];
  var i = 0;

  function split() {
    if (i === data.length) {
      throw new Error('Ran out of data');
    }
    var byte = data[i];
    i++;
    var byte8 = void 0,
        byte7 = void 0,
        byte6 = void 0,
        byte5 = void 0,
        byte4 = void 0,
        byte3 = void 0,
        byte2 = void 0,
        byte1 = void 0;
    switch (depth) {
      default:
        throw new Error('unrecognised depth');
      case 16:
        byte2 = data[i];
        i++;
        leftOver.push((byte << 8) + byte2);
        break;
      case 4:
        byte2 = byte & 0x0f;
        byte1 = byte >> 4;
        leftOver.push(byte1, byte2);
        break;
      case 2:
        byte4 = byte & 3;
        byte3 = byte >> 2 & 3;
        byte2 = byte >> 4 & 3;
        byte1 = byte >> 6 & 3;
        leftOver.push(byte1, byte2, byte3, byte4);
        break;
      case 1:
        byte8 = byte & 1;
        byte7 = byte >> 1 & 1;
        byte6 = byte >> 2 & 1;
        byte5 = byte >> 3 & 1;
        byte4 = byte >> 4 & 1;
        byte3 = byte >> 5 & 1;
        byte2 = byte >> 6 & 1;
        byte1 = byte >> 7 & 1;
        leftOver.push(byte1, byte2, byte3, byte4, byte5, byte6, byte7, byte8);
        break;
    }
  }

  return {
    get: function get(count) {
      while (leftOver.length < count) {
        split();
      }
      var returner = leftOver.slice(0, count);
      leftOver = leftOver.slice(count);
      return returner;
    },
    resetAfterLine: function resetAfterLine() {
      leftOver.length = 0;
    },
    end: function end() {
      if (i !== data.length) {
        throw new Error('extra data found');
      }
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/pngjs3/dist/dataToBitMap/bitRetriever.js
// module id = 1091
// module chunks = 0